import { SearchInterface } from "./interfaces";

export const initialSearchValues: SearchInterface = {
    year: 2000,
    make: "",
    model: "",
    trim: "",
    priceLow: 0,
    priceHigh: 20000,
    mileageLow: 0,
    mileageHigh: 100000,
    color: "balck"
  };